import { ILogger } from './interface';
import { ConsoleLogger } from './console-logger';
import { ProductionLogger } from './production-logger';
import { datadogLogs } from '@datadog/browser-logs';
import { NoOpLogger } from './no-op-logger';

class LoggerSingleton {
  private static instance: ILogger | null = null;
  private static isInitialized = false;

  static getInstance(): ILogger {
    if (!LoggerSingleton.instance) {
      LoggerSingleton.init();
    }
    return LoggerSingleton.instance!;
  }

  static init() {
    if (LoggerSingleton.isInitialized) return;

    const environment = process.env.NODE_ENV || 'development';

    try {
      if (environment === 'production') {
        datadogLogs.init({
          clientToken: 'pub50c7fcf0091ebc579af6045c73e5c209',
          site: 'datadoghq.com',
          forwardErrorsToLogs: true,
          sessionSampleRate: 100,
          forwardConsoleLogs: [],
          service: 'web-app',
        });
        LoggerSingleton.instance = new ProductionLogger();
        LoggerSingleton.isInitialized = true;
        return;
      }

      if (environment === 'development') {
        LoggerSingleton.instance = new ConsoleLogger();
        LoggerSingleton.isInitialized = true;
        return;
      }

      if (environment === 'test') {
        LoggerSingleton.instance = new NoOpLogger();
        LoggerSingleton.isInitialized = true;
        return;
      }

      // Default to NoOpLogger
      LoggerSingleton.instance = new NoOpLogger();
      LoggerSingleton.isInitialized = true;
    } catch (error) {
      LoggerSingleton.instance = new NoOpLogger();
      LoggerSingleton.isInitialized = true;
    }
  }
}

export const getLogger = () => LoggerSingleton.getInstance();
